// Shared by LegendsContainer and MapRecordingLegends
@use "legend-layout" as *;

.map-legend-container-hidden {
  display: none !important;
}

.map-legend-container {
  left: $legend-inset;
  bottom: $legend-bottom;
  display: flex;
  flex-direction: column;
  position: absolute;
  overflow: visible;
  pointer-events: all;
  max-width: 80%;
  max-height: 65%;

  box-sizing: border-box;
  background: transparent;
}

// must stay after .map-legend-container, both set bottom
.bottom-legend {
  bottom: $legend-bottom-raised;
}

.top-legend {
  max-height: 55%;
}

.content-container {
  display: flex;
  flex-direction: row;
  height: 100%;
  width: 100%;
  border: 1px solid var(--color-border-secondary);
  user-select: none;
}
